import useTimezone from '@/hooks/useTimezone';
import { Card, Table } from 'antd';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { getPortfoliosTableColumns } from '../tableColumns';

const PortfoliosTable = ({
  portfolios,
  onStatusToggle,
  onEdit,
  loading,
  togglingPortfolioId,
  pagination,
  onTableChange,
}) => {
  const { timezone } = useTimezone();

  const currentPage = pagination?.current || 1;
  const pageSize = pagination?.pageSize || 10;

  const columns = useMemo(
    () =>
      getPortfoliosTableColumns({
        onStatusToggle,
        onEdit,
        currentPage,
        pageSize,
        togglingPortfolioId,
        timezone,
      }),
    [onStatusToggle, onEdit, currentPage, pageSize, togglingPortfolioId, timezone]
  );

  return (
    <Card styles={{ body: { padding: 0 } }}>
      <Table
        columns={columns}
        dataSource={portfolios}
        rowKey="portfolioId"
        loading={loading}
        onChange={onTableChange}
        pagination={{
          current: currentPage,
          pageSize,
          total: pagination?.total || 0,
          showSizeChanger: true,
          showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
        }}
        scroll={{ x: 1100 }}
      />
    </Card>
  );
};

PortfoliosTable.propTypes = {
  portfolios: PropTypes.array.isRequired,
  onStatusToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  togglingPortfolioId: PropTypes.string,
  pagination: PropTypes.object,
  onTableChange: PropTypes.func,
};

export default PortfoliosTable;
